 (function () {  
    function bindUpsellAddToCart() {
      if (window.__cartUpsellAtcBound) return
      window.__cartUpsellAtcBound = true

      // Capture submit before browser navigation.
      document.addEventListener(
        'submit',
        async (event) => {
          const form = event.target
          if (!form || !form.closest) return

          // Only intercept our cart upsell forms.
          const upsellRoot = form.closest('#cart-drawer-upsell')
          if (!upsellRoot) return
          if (!form.matches('form[action*="/cart/add"]') && !form.matches('form[action*="cart/add"]')) return

          // Prevent Shopify's `product-form.js` submit handler from running for upsell forms.
          // (Upsell markup doesn't include `.loading__spinner`, so product-form would throw.)
          event.preventDefault()
          event.stopPropagation()
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation()

          const submitBtn = form.querySelector('[type="submit"]')
          const spinner = submitBtn ? submitBtn.querySelector('.cart-drawer-upsell-spinner') : null

          if (submitBtn) {
            submitBtn.setAttribute('aria-disabled', 'true')
            submitBtn.classList.add('is-loading')
          }
          if (spinner) spinner.classList.remove('hidden')

          try {
            const formData = new FormData(form)
            if (!formData.has('quantity')) formData.append('quantity', '1')

            // Request sections for cart drawer/icon so the UI updates instantly.
            const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
            if (cart && typeof cart.getSectionsToRender === 'function') {
              try {
                formData.append(
                  'sections',
                  cart.getSectionsToRender()
                    .map((section) => section.id)
                    .join(',')
                )
                formData.append('sections_url', window.location.pathname)
              } catch (e) {
                // noop - sections are an enhancement, not required for add-to-cart
              }
            }

            const url =
              (window.routes && window.routes.cart_add_url) ||
              (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
                ? `${window.Shopify.routes.root}cart/add`
                : '/cart/add')

            const res = await fetch(url, {
              method: 'POST',
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                Accept: 'application/json'
              },
              body: formData
            })

            const json = await res.json()
            if (json && json.status) {
              console.error('Upsell add-to-cart error:', json)
              return
            }

            // Ensure drawer stays open (if present).
            const cartDrawer = document.querySelector('cart-drawer')
            if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open()

            // Refresh cart UI (best-effort, mirrors `assets/product-form.js`).
            // 1) Render drawer/icon sections if available
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(json)
            }

            // 2) Trigger the cart-drawer section fetch so the Maison progress bar runs its smooth animation
            // (`assets/cart.js` -> CartItems.onCartUpdate -> updateProgressBar).
            const triggerDrawerRefresh = () => {
              const cartItems =
                document.querySelector('cart-drawer-items') || document.querySelector('cart-items')
              if (cartItems && typeof cartItems.onCartUpdate === 'function') {
                cartItems.onCartUpdate()
              }
            }

            // If we just replaced drawer DOM via renderContents, wait a tick so the new custom element is connected.
            if (cart && typeof cart.renderContents === 'function') {
              setTimeout(triggerDrawerRefresh, 0)
            } else {
              triggerDrawerRefresh()
            }

            // 3) Publish events for any other listeners
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'cart-upsell',
                productVariantId: formData.get('id'),
                cartData: json
              })
            }
            document.dispatchEvent(new CustomEvent('cart:updated'))
          } catch (e) {
            console.error('Upsell add-to-cart failed:', e)
          } finally {
            if (spinner) spinner.classList.add('hidden')
            if (submitBtn) {
              submitBtn.classList.remove('is-loading')
              submitBtn.removeAttribute('aria-disabled')
            }
          }
        },
        true
      )
    }

    function initUpsellControls(root) {
      if (!root) return

      const upsellList = root.querySelector('.cart-drawer-upsell-list[data-list-style-cart-drawer="scroll"]')
      if (!upsellList) return

      const items = upsellList.querySelectorAll('.cart-drawer-upsell-list-item')
      if (!items || items.length <= 1) return

      const prevBtn = root.querySelector('.cart-drawer-upsell-prev')
      const nextBtn = root.querySelector('.cart-drawer-upsell-next')
      const pagination = root.querySelector('.cart-drawer-upsell-pagination')

      // Build pagination (bars) to match Figma, one per item.
      if (pagination) {
        pagination.innerHTML = ''
        items.forEach((_, idx) => {
          const el = document.createElement('span')
          el.className = 'cart-drawer-upsell-page'
          el.dataset.index = String(idx)
          pagination.appendChild(el)
        })
      }

      function getCurrentIndex() {
        const w = upsellList.clientWidth || 1
        return Math.max(0, Math.min(items.length - 1, Math.round(upsellList.scrollLeft / w)))
      }

      function scrollToIndex(index) {
        const w = upsellList.clientWidth || 1
        upsellList.scrollTo({ left: index * w, behavior: 'smooth' })
      }

      function updateUI() {
        const idx = getCurrentIndex()
        if (prevBtn) prevBtn.disabled = idx === 0
        if (nextBtn) nextBtn.disabled = idx === items.length - 1
        if (pagination) {
          pagination.querySelectorAll('.cart-drawer-upsell-page').forEach((p) => {
            p.classList.toggle('is-active', Number(p.dataset.index) === idx)
          })
        }
      }

      if (prevBtn && !prevBtn.dataset.upsellBound) {
        prevBtn.dataset.upsellBound = '1'
        prevBtn.addEventListener('click', () => {
          const idx = getCurrentIndex()
          if (idx > 0) scrollToIndex(idx - 1)
        })
      }

      if (nextBtn && !nextBtn.dataset.upsellBound) {
        nextBtn.dataset.upsellBound = '1'
        nextBtn.addEventListener('click', () => {
          const idx = getCurrentIndex()
          if (idx < items.length - 1) scrollToIndex(idx + 1)
        })
      }

      if (pagination && !pagination.dataset.upsellBound) {
        pagination.dataset.upsellBound = '1'
        pagination.addEventListener('click', (e) => {
          const t = e.target
          if (!t || !t.classList || !t.classList.contains('cart-drawer-upsell-page')) return
          const idx = Number(t.dataset.index)
          if (!Number.isFinite(idx)) return
          scrollToIndex(idx)
        })
      }

      if (!upsellList.dataset.upsellBound) {
        upsellList.dataset.upsellBound = '1'
        upsellList.addEventListener('scroll', () => {
          window.requestAnimationFrame(updateUI)
        }, { passive: true })
        window.addEventListener('resize', updateUI)
      }

      updateUI()
    }

    async function insertSectionCartDrawer() {
      if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return

      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      if (cartDrawerItems.classList.contains('is-empty')) return

      var wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)
 
      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }

      initUpsellControls(document.querySelector('#cart-drawer-upsell'))
    }
    bindUpsellAddToCart()
    insertSectionCartDrawer()

  /*  async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartPage() */
    
    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const selectedOption = select.options[select.selectedIndex]
      const item = select.closest('.cart-drawer-upsell-list-item')
      if (!selectedOption || !item) return

      const imgSrc = selectedOption.dataset.variantImg

      if (imgSrc) {
        const img = item.querySelector('.cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }

      const priceEl = item.querySelector('[data-upsell-price]')
      const compareEl = item.querySelector('[data-upsell-compare]')

      if (priceEl) {
        const soldOutText = select.dataset.soldOutText || 'Sold out'
        const isSoldOut = selectedOption.dataset.variantSoldOut === '1'
        priceEl.textContent = isSoldOut ? soldOutText : (selectedOption.dataset.variantPrice || '')
      }

      if (compareEl) {
        const isSoldOut = selectedOption.dataset.variantSoldOut === '1'
        const compare = selectedOption.dataset.variantCompareAtPrice || ''
        const shouldShowCompare = !isSoldOut && Boolean(compare)
        compareEl.hidden = !shouldShowCompare
        compareEl.textContent = shouldShowCompare ? compare : ''
      }
    }

    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      if (!element) return
  
      let timer 
       
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))
 
            insertSectionCartDrawer()
        }, 250)
      })

      observer.observe(element, {  
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartDrawer()

    function listenCartPage() {
      const element = document.querySelector('#MainContent .cart__items')
      if (!element) return

      let timer
      
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))

            insertSectionCartPage()
        }, 250)
      })

      observer.observe(element, { 
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartPage()
  })();